import Event from '../../core/Event';

export default class CustomersRequested extends Event {
    public static type = 'CustomersRequested';

    constructor() {
        super(CustomersRequested.type);
    }
}



// WEBPACK FOOTER //
// ./src/application/admin/events/CustomersRequested.ts